<template>
  <div class="skeleton-loader">
    <!-- Article/Page Title Skeleton -->
    <div v-if="type === 'article'" class="skeleton-article">
      <div class="skeleton-title skeleton-pulse"></div>
      <div class="skeleton-line skeleton-pulse" style="width: 90%;"></div>
      <div class="skeleton-line skeleton-pulse" style="width: 85%;"></div>
      <div class="skeleton-line skeleton-pulse" style="width: 92%;"></div>
      <div class="skeleton-spacing"></div>
      <div class="skeleton-line skeleton-pulse" style="width: 88%;"></div>
      <div class="skeleton-line skeleton-pulse" style="width: 94%;"></div>
      <div class="skeleton-line skeleton-pulse" style="width: 86%;"></div>
    </div>

    <!-- Collection/Category List Skeleton -->
    <div v-else-if="type === 'collection'" class="skeleton-collection">
      <div class="skeleton-title skeleton-pulse"></div>
      <div class="skeleton-spacing"></div>
      
      <div v-for="n in itemCount" :key="n" class="skeleton-category">
        <div class="skeleton-category-title skeleton-pulse"></div>
        <div class="skeleton-list-item skeleton-pulse"></div>
        <div class="skeleton-list-item skeleton-pulse"></div>
        <div class="skeleton-list-item skeleton-pulse"></div>
      </div>
    </div>

    <!-- Category Articles List Skeleton -->
    <div v-else-if="type === 'category'" class="skeleton-category-list">
      <div class="skeleton-title skeleton-pulse"></div>
      <div class="skeleton-spacing"></div>
      
      <div v-for="n in itemCount" :key="n" class="skeleton-list-item skeleton-pulse"></div>
    </div>

    <!-- Collections Grid Skeleton (for SupportDocs page) -->
    <div v-else-if="type === 'docs'" class="skeleton-docs">
      <div class="skeleton-docs__grid">
        <div v-for="n in itemCount" :key="n" class="skeleton-docs__card">
          <div class="skeleton-docs__icon skeleton-pulse"></div>
          <div class="skeleton-docs__card-title skeleton-pulse"></div>
          <div class="skeleton-docs__card-line skeleton-pulse" style="width: 90%;"></div>
          <div class="skeleton-docs__card-line skeleton-pulse" style="width: 75%;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkeletonLoader",
  props: {
    type: {
      type: String,
      default: 'article',
      validator: (value) => ['article', 'collection', 'category', 'docs'].includes(value)
    },
    itemCount: {
      type: Number,
      default: 3
    }
  }
};
</script>

<style scoped>
.skeleton-loader {
  padding: 20px 0;
}

/* Pulsing animation */
.skeleton-pulse {
  animation: skeleton-pulse 1.5s ease-in-out infinite;
  background: linear-gradient(90deg, var(--color-gray-100) 25%, var(--color-gray-200) 50%, var(--color-gray-100) 75%);
  background-size: 200% 100%;
}

@keyframes skeleton-pulse {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Common skeleton elements */
.skeleton-title {
  height: 36px;
  width: 60%;
  border-radius: 8px;
  margin-bottom: 16px;
}

.skeleton-line {
  height: 16px;
  border-radius: 8px;
  margin-bottom: 12px;
}

.skeleton-spacing {
  height: 24px;
}

/* Article specific - matches .support-article max-width and centering */
.skeleton-article {
  max-width: 640px;
  margin: 0 auto;
}

.skeleton-article .skeleton-title {
  width: 70%;
  height: 36px;
}

.skeleton-article .skeleton-line {
  width: 100%;
}

/* Collection specific - full width like actual content */
.skeleton-collection {
  width: 100%;
}

.skeleton-collection .skeleton-title {
  width: 50%;
  max-width: 400px;
}

.skeleton-category {
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid var(--color-gray-100);
}

.skeleton-category-title {
  height: 24px;
  width: 35%;
  max-width: 300px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.skeleton-list-item {
  height: 48px;
  border-radius: 8px;
  margin-bottom: 12px;
}

/* Category list specific - full width */
.skeleton-category-list {
  width: 100%;
}

.skeleton-category-list .skeleton-title {
  width: 45%;
  max-width: 350px;
}

/* Collections/Docs grid skeleton - matches .support-collections */
.skeleton-docs {
  width: 100%;
}

.skeleton-docs__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 10px;
}

@media (max-width: 992px) {
  .skeleton-docs__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 576px) {
  .skeleton-docs__grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.skeleton-docs__card {
  padding: 24px;
  border: 1px solid var(--color-gray-100);
  border-radius: 16px;
  background: white;
}

.skeleton-docs__icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  margin-bottom: 16px;
}

.skeleton-docs__card-title {
  height: 20px;
  width: 70%;
  border-radius: 4px;
  margin-bottom: 12px;
}

.skeleton-docs__card-line {
  height: 14px;
  border-radius: 8px;
  margin-bottom: 8px;
}
</style>

